import { useMemo } from 'react';
import { get } from 'lodash';
import { ChipProps } from '@mui/material';

import { Nullable } from '~globals/types';
import {
  RouteItemStateType,
  CollectItemStateTypes,
} from '~globals/types/enums';

interface OrderPendingStateInfoItem {
  description: string;
  color: NonNullable<ChipProps['color']>;
  tooltipMessage: string;
}

type OrderPendingStateType =
  | RouteItemStateType.New
  | CollectItemStateTypes.Validated;

type OrderPendingStateList = {
  [state in OrderPendingStateType]: OrderPendingStateInfoItem;
};

interface UseOrderPendingParams {
  itemStateTypeId: RouteItemStateType;
  collectItemStateTypeId: Nullable<CollectItemStateTypes>;
}

export const useOrderPendingStateInfo = ({
  itemStateTypeId,
  collectItemStateTypeId,
}: UseOrderPendingParams): OrderPendingStateInfoItem => {
  const stateList = useMemo<OrderPendingStateList>(
    () => ({
      [RouteItemStateType.New]: {
        description: 'Recepcionado',
        color: 'quaternary',
        tooltipMessage: 'Ingresada al depósito del transportista.',
      },
      [CollectItemStateTypes.Validated]: {
        description: 'Colectado',
        color: 'success',
        tooltipMessage: 'El transportista ya la tiene en su poder.',
      },
    }),
    [],
  );

  const currentInfo = useMemo<OrderPendingStateInfoItem>(() => {
    const type: OrderPendingStateType =
      itemStateTypeId === RouteItemStateType.New &&
      collectItemStateTypeId === CollectItemStateTypes.Validated
        ? CollectItemStateTypes.Validated
        : RouteItemStateType.New;

    return get(stateList, type);
  }, [collectItemStateTypeId, itemStateTypeId, stateList]);

  return currentInfo;
};
